export default __webpack_public_path__ + "static/media/today-face.5a6180eb.svg";